import CoreMessageDispatcher from '../../core/controller/CoreMessageDispatcher';
import CoreEvents from '../../core/events/CoreEvents';
import ChangeOrders from '../../core/events/ChangeOrders';
const SizesUtils = require('../../../../viscomjs/utils/SizesUtils');
const _dispatcher = CoreMessageDispatcher.instance();

const _start = mdr => {
    if (mdr.started) return mdr;

    mdr._update(true);
    _addCoreListeners(mdr, true);

    mdr.started = true;
    return mdr;
};

const _stop = mdr => {
    if (!mdr.started) return mdr;

    _addCoreListeners(mdr, false);

    mdr.started = false;
    return mdr;
};

const _update = (mdr, force) => {
    if (!mdr.started && !force) return mdr;

    mdr.state.isOn = mdr.model.helperOpen;

    const w = SizesUtils.winWidth();
    const h = SizesUtils.winHeight();

    // eslint-disable-next-line no-empty
    if (h > w || (w <= 425 || h <= 425) || (w > 425 && w <= 768 && h > 425 && h < w)) {
        mdr.el.dataset.isOn = mdr.state.isOn;
    } else {
        _dispatcher.emit(ChangeOrders.CLOSE_HELPER);
    }

    return mdr;
};

//

//
// From Core
//
const _addCoreListeners = (mdr, b) => {
    if (b) {
        _dispatcher.on(CoreEvents.HELPER_STATE_CHANGED, mdr._update);
        return;
    }

    _dispatcher.off(CoreEvents.HELPER_STATE_CHANGED, mdr._update);
};

//

//
// Constructor
//
const HelperDisplayMediator = (el, model) => {
    const mdr = {
        el: el,
        model: model,
        state: {
            isOn: true,
            state: ''
        }
    };

    mdr.start = () => {
        return _start(mdr);
    };

    mdr._update = force => {
        return _update(mdr, force);
    };

    mdr.stop = () => {
        return _stop(mdr);
    };

    return mdr;
};

export {HelperDisplayMediator};
export default HelperDisplayMediator;
